export const allTypes = ['pants', 'outerwear', 'hair', 'glasses', 'skin', 'footwear']

export const SLOT_TO_3D_TYPE = {
  hats: 'hair',
  trousers: 'pants',
  accessories: 'glasses',
  outerwear: 'outerwear',
  footwear: 'footwear',
}

export const allSlots = Object.keys(SLOT_TO_3D_TYPE)
